import React, { useRef, useState } from 'react';
import App from './App';
import { QueryClientProvider, QueryClient, QueryCache, MutationCache } from 'react-query';
import useAuthContext from './hooks/useAuthContext';

const AppInitializer = () => {
    const { dispatcher } = useAuthContext();
    const dispatcherRef = useRef(dispatcher);
    dispatcherRef.current = dispatcher;
    const [queryClient] = useState(
        () =>
            new QueryClient({
                queryCache: new QueryCache({
                    onError: error => {
                        if (error?.response?.status === 401) {
                            dispatcherRef.current({ type: 'LOGOUT' });
                            localStorage.clear();
                        }
                    },
                }),
                mutationCache: new MutationCache({
                    onError: err => {
                        if (err?.response?.status === 401) {
                            dispatcherRef.current({ type: 'LOGOUT' });
                            localStorage.clear();
                        }
                    },
                }),
            })
    );

    return (
        <>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </>
    );
};

export default AppInitializer;
